import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeItemModifierModal, orderItemModifierAdd, modalReset } from '../actions/index';
import { Modal } from 'react-bootstrap';

class ModalItemModifier extends Component {
  constructor(props) {
    super(props);

    this.state = {
      itemModifiers: '',
      activeModifierGroup: '',
      currentMods: {},
    }
  }

  // When someone clicks on the mod button, the props will change so use
  // here to pre-populate the message with the stored value
  componentWillReceiveProps(nextProps) {
    if (this.props.modals.modalCurrentOrderItemID !== '') {

      // Grab the itemID and categoryID from the current order item
      let itemID = this.props.current_order.items[this.props.modals.modalCurrentOrderItemID].id;
      let categoryID = this.props.current_order.items[this.props.modals.modalCurrentOrderItemID].cat_id;

      // Grab the modifiers for the current item in the modal state and in the current order
      let itemModifiers = this.props.restaurant.menuItems[categoryID].items[itemID].modifiers;
      let currentMods = this.props.current_order.items[this.props.modals.modalCurrentOrderItemID].modifiers;

      // Only set the local state if we have some modifiers
      if (Object.keys(itemModifiers).length !== 0) {
        // Set local state with modifiers and set an initial active category (first one in array)
        this.setState({
          itemModifiers: itemModifiers,
          activeModifierGroup: parseInt(Object.keys(itemModifiers)[0], 10),
          currentMods: currentMods
        });
      }
    }
  }

  // Change the active group
  handleGroupClick = (groupID) => {
    this.setState({ activeModifierGroup: groupID });
  }

  // Add modifiers to the state for the current item
  handleAddItemModifier = (groupID, modifierID) => {
    let currentMods = this.state.currentMods;

    // If the group object doesnt exist, create a blank one
    if (!currentMods[groupID]) currentMods[groupID] = {};

    // If the proprty exists, we already clicked it, so remove, otherwise, add it
    if (currentMods[groupID].hasOwnProperty(modifierID)) {
      delete currentMods[groupID][modifierID];
    } else {
      // Does the group allow multiple choices or not?
      if (this.state.itemModifiers[groupID].multiple) {
        currentMods[groupID][modifierID] = true;
      } else {
        // Clear the group and add the one item
        currentMods[groupID] = {};
        currentMods[groupID][modifierID] = true;
      }
    }

    this.setState({ currentMods: currentMods });
  }

  //Add modifiers to the current_order item
  handleAddItemModifiers = () => {
    this.props.orderItemModifierAdd(this.props.modals.modalCurrentOrderItemID, this.state.currentMods);
    this.props.closeItemModifierModal();
    this.props.modalReset(); // Removes item id from modal state
  }

  // Render the header listing the modifier groups for this item
  renderModGroups() {
    var modGroups = Object.values(this.state.itemModifiers);

    return modGroups.map( (group, index) => {
      var cls = (this.state.activeModifierGroup === group.id) ? 'nav-link active' : 'nav-link';

      return(
        <li key={group.id} className="nav-item">
          <a className={cls} onClick={event => this.handleGroupClick(group.id)} href={"#" + group.name}>{group.name}</a>
        </li>
      );
    });
  }

  // Render the modifiers for the active group
  renderModifiers() {
    // Does the state have modifiers for this group?
    if (this.state.itemModifiers !== '' && this.state.activeModifierGroup !== '') {
      var modifiers = Object.values(this.state.itemModifiers[this.state.activeModifierGroup].modifiers);
    } else {
      return <div>There are no modifiers</div>;
    }

    return modifiers.map( (modifier, index) => {
      // Check the state to see if this mod has been clicked or not
      var cls = 'btn btn-outline-primary btn-block';
      if (this.state.currentMods[this.state.activeModifierGroup] && this.state.currentMods[this.state.activeModifierGroup][modifier.id]) {
        cls = 'btn btn-primary btn-block';
      }
      //var cls = (this.state.currentMods[this.state.activeModifierGroup].hasOwnProperty(modifier.id)) ? 'btn btn-primary btn-block' : 'btn btn-outline-primary btn-block';
      return (
        <div key={modifier.id}>
          <br />
          <button onClick={event => this.handleAddItemModifier(this.state.activeModifierGroup, modifier.id)} className={cls}>{modifier.name} - ${modifier.price.toFixed(2)}</button>
        </div>
      );
    });
  }

  render() {
    return(
      <Modal show={this.props.modals.showItemModifierModal} onHide={this.props.closeItemModifierModal}>
        <Modal.Header closeButton>
          <Modal.Title>Item Modifiers</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul className="nav nav-tabs">
            {this.renderModGroups()}
          </ul>
          <div className="center-text">
            {this.renderModifiers()}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-secondary" onClick={this.props.closeItemModifierModal}>Close</button>&nbsp;
          <button type="button" className="btn btn-primary" onClick={this.handleAddItemModifiers}>Save Changes</button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps({ modals, restaurant, current_order }) {
  return { modals, restaurant, current_order };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators( { closeItemModifierModal, orderItemModifierAdd, modalReset }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalItemModifier);



// WEBPACK FOOTER //
// ./src/containers/modal_item_modifier.js